module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.documents[_vm.currentDocument]) ? _c('div', {
    staticClass: "document"
  }, [_c('progress-bar'), _vm._v(" "), _c('h3', {
    staticClass: "document__header"
  }, [_c('icon', {
    attrs: {
      "name": "envelope-open",
      "height": "15",
      "width": "20"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.documents[_vm.currentDocument].title))])], 1), _vm._v(" "), _vm._l((_vm.documents[_vm.currentDocument].pages), function(page, pageIndex) {
    return [_c('div', {
      staticClass: "document__page"
    }, [_c('img', {
      attrs: {
        "src": page.src
      }
    }), _vm._v(" "), (_vm.documents[_vm.currentDocument].fields[pageIndex + 1]) ? [_vm._l((_vm.documents[_vm.currentDocument].fields[pageIndex + 1]), function(field, fieldIndex) {
      return [_c('document-field', {
        key: field.id,
        attrs: {
          "pageIndex": pageIndex + 1,
          "fieldIndex": fieldIndex,
          "field": field,
          "openFieldPopup": _vm.openFieldPopup,
          "closeFieldPopup": _vm.closeFieldPopup,
          "activePopupId": _vm.activePopupId
        }
      })]
    })] : _vm._e()], 2)]
  }), _vm._v(" "), (_vm.documents.length > 1) ? _c('document-navigation') : _vm._e()], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ffd10882","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Document.vue
// module id = 1067
// module chunks = 1